import {
  ICartAddressDetails,
  ICartSearchResponseData,
  IHDCartAddressListResponseData,
} from "@/api_framework/api_modals/Cart";
import { ICartTableFormPetItem } from "../CartCreationTableComponent";
import { useEffect, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import PetCartTableRow from "../PetCartTableRow";
import AlertBlue from "@/app/components/ui/Alerts/Blue";

const PetCartTable: React.FC<{
  alreadyAddedURIDError: string | null;
  cartLevelCouponId: string;
  petCart: ICartTableFormPetItem;
  activeCartId: string;
  fetchLotDetails: (
    item: ICartSearchResponseData,
    swap?: boolean,
    editLotDetails?: boolean,
    isRefreshCart?: boolean,
  ) => void;
  selectedAddress?: ICartAddressDetails | null;
  currentAddress?: IHDCartAddressListResponseData | null;
}> = ({
  alreadyAddedURIDError,
  cartLevelCouponId,
  petCart,
  activeCartId,
  fetchLotDetails,
  selectedAddress,
  currentAddress,
}) => {
  const [selected, setSelected] = useState<string[]>([]);

  const formHook = useForm<ICartTableFormPetItem>({
    defaultValues: {},
  });

  const formArrayHook = useFieldArray<ICartTableFormPetItem>({
    name: "items",
    control: formHook.control,
  });

  useEffect(() => {
    formHook.setValue("items", petCart.items);
    formHook.setValue("pet_id", petCart.pet_id);
    formHook.setValue("pet_name", petCart.pet_name);
  }, [petCart]);

  return (
    <>
      {formArrayHook.fields?.length > 0 ? (
        <div>
          <table className="bg-white w-full">
            <thead>
              <tr className="bg-[#f5f5f5] text-left text-xs font-medium top-0 sticky z-10">
                <th className="sticky top-0 font-medium text-black text-xs px-4 py-2 z-20">Services & Goods</th>
                <th className="sticky top-0 font-medium text-black text-xs px-4 py-2 z-20">Quantity</th>
                <th className="sticky top-0 font-medium text-black text-xs px-4 py-2 z-20">Unit Price</th>
                <th className="sticky top-0 font-medium text-black text-xs px-4 py-2 z-20">Gross</th>
                <th className="sticky top-0 font-medium text-black text-xs px-4 py-2 z-20">Coupon</th>
                <th className="sticky top-0 font-medium text-black text-xs px-4 py-2 z-20">Net</th>
                <th className="sticky top-0 font-medium text-black text-xs px-4 py-2 z-20"></th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {formArrayHook.fields.map((field, index) => (
                <PetCartTableRow
                  key={index}
                  alreadyAddedURIDError={alreadyAddedURIDError}
                  cartLevelCouponId={cartLevelCouponId}
                  row={formHook.watch(`items.${index}`)}
                  fetchLotDetails={fetchLotDetails}
                  activeCartId={activeCartId}
                  selected={selected}
                  setSelected={setSelected}
                  formHook={formHook}
                  rowIndex={index}
                  rowPetId={petCart.pet_id}
                  rowIdKey={field.id}
                  selectedAddress={selectedAddress}
                  currentAddress={currentAddress}
                />
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <AlertBlue title={`No available active items in the cart for ${formHook.getValues("pet_name")}.`} />
      )}
    </>
  );
};

export default PetCartTable;
